import { Box, Typography } from "@mui/material";
import { ParameterConflict } from "store/api/generatedApi";
import { ConflictDescription } from "./ConflictDescription";
import { groupConflictReasons } from "./groupConflictReasons";

export const ConflictReasons = ({
  conflicts,
  chefGroupNameById,
  limitLabelBySignature,
}: {
  conflicts: ParameterConflict[];
  chefGroupNameById: Record<number, string>;
  limitLabelBySignature: Record<string, string>;
}) => (
  <>
    {groupConflictReasons(conflicts).map(({ key, conflict, chefGroupIds }) => {
      const signature = conflict.coefficients_signature ?? "";
      return (
        <Box key={key} sx={{ mb: 0.5 }}>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontWeight: "fontWeightBold" }}
          >
            {chefGroupIds
              .map((id) => chefGroupNameById[id] ?? String(id))
              .join(", ")}
          </Typography>
          <ConflictDescription
            conflict={conflict}
            limitLabel={limitLabelBySignature[signature] ?? signature}
          />
        </Box>
      );
    })}
  </>
);
